import { FiVoicemail } from "react-icons/fi";
import { MdPhoneMissed } from "react-icons/md";
import { FaPersonCircleXmark } from "react-icons/fa6";
import { formatRelativeDate } from "../../services/helper";
import { colors } from "../../utils/constants/colors";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { modifyNotification } from "../../redux/actions/notification";
import { useDispatch } from "react-redux";
import { toast } from "../CommonComponents/ToastComponent/toast";

const NotificationMenu = ({ notification, redirectHandler, setShowNotification }) => {
    let history = useHistory()
    let dispatch = useDispatch()
    let time = formatRelativeDate(notification?.createdAt || '2025-04-16 17:59:03.696+05:30')
    let header = ''
    let body = ''

    if (notification?.type === 'email') {
        header = notification?.emailFrom
        body = notification?.bodyPreview?.slice(0, 30) + '...'
    } else if (notification?.type === 'missedCall') {
        header = notification?.externalNumber
        body = 'Missed Call'
    } else if (notification?.type === 'rejected') {
        header = notification?.suppliername
        body = 'Rejected'
    }

    const onClickMenu = async () => {
        try {
            setShowNotification(false)
            await dispatch(modifyNotification([notification?.id], 'markAsRead', notification?.type))
            redirectHandler(notification?.type)
        } catch (err) {
            toast.show({
                title: 'Danger',
                description: `Unable To Update Notification`,
            })
        }
    }

    return (
        <div
            className={`d-flex w-100 rounded mt-3 menu ${!notification?.isRead && 'border'}`}
            key={notification?.id}
            style={{ backgroundColor: notification?.isRead ? colors.blue100 : '' }}
            onClick={onClickMenu}
        >
            <div className="d-flex justify-content-center align-items-center mx-3">
                {
                    notification?.type === 'email' ? <button className="rounded-circle border p-3 d-flex justify-content-center" style={{ height: 50, width: 50 }} ><i class="bi bi-envelope fs-1 align-self-center"></i>
                    </button> : notification?.type === 'missedCall' && notification?.isVoicemail ? <button className="rounded-circle border p-3 d-flex justify-content-center" style={{ height: 50, width: 50 }} ><FiVoicemail size={25} /></button> : notification?.type === 'missedCall' ? <button className="rounded-circle border p-3 d-flex justify-content-center" style={{ height: 50, width: 50 }} ><MdPhoneMissed size={25} /></button> : <button className="rounded-circle border p-3 d-flex justify-content-center" style={{ height: 50, width: 50 }} ><FaPersonCircleXmark size={25} /></button>
                }
            </div>
            <div>
                {
                    <div className="px-4 py-2 d-flex flex-column row-gap-2 w-100">
                        <h4 className="m-0 fs-4">{header}</h4>
                        <p className="m-0  fs-5">{body}</p>
                        <p className="m-0 fs-6">{time}</p>
                    </div>
                }
            </div>
        </div>
    )
}
export default NotificationMenu